import { Component, OnInit, Output } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AdminSetupService } from "../../services/adminsetup.service";

@Component({
	selector: "app-change-multiple",
	templateUrl: "./change-multiple.component.html",
	styleUrls: ["./change-multiple.component.css"],
})
export class ChangeMultipleComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef, private adminSetupService: AdminSetupService) {}

	ngOnInit(): void {
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.lstSchoolDay = this.dialogConfig.data.lstSchoolDay;
		if (this.lstSchoolDay[0].DayID != -100) {
			this.lstSchoolDay.unshift({
				DayID: -100,
				DayDesc: "Don't Change",
			});
		}

		this.lstBellSchedule = this.dialogConfig.data.lstBellSchedule;
		if (this.lstBellSchedule[0].BellScheduleID != -100) {
			this.lstBellSchedule.unshift({
				BellScheduleID: -100,
				BellScheduleDesc: "Don't Change",
			});
		}

		this.loadDateOptions();
	}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////

	SchoolID: number = -1;
	SelectionID: any = "1";

	DOW: any = "Monday";
	lstDOW: any = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

	SchoolDayID: any = -100;
	lstSchoolDay: any = [];

	BellScheduleID: any = -100;
	lstBellSchedule: any = [];

	IsOpen: any = "Don't Change";
	lstIsOpen: any = ["Don't Change", "Open", "Closed"];

	EveryXDays: any = 1;
	StartDay: any = 1;
	SkipWeekends: any = false;

	DateModeID: number = 0;
	StartMonthYear: any;
	EndMonthYear: any;
	lstMonthYear: any = [];

	lstSemester: any = [];
	SchoolYearSemesters: any = [];

	SemesterLoading: boolean = false;
	Processing: boolean = false;

	////////////////////////////////////////

	////////////////////////////////////////
	// Load Data
	////////////////////////////////////////

	loadDateOptions() {
		this.loadMonthYear();
		this.loadSemesters();
	}

	loadMonthYear() {
		var Today = new Date();
		var StartDate = new Date(Today.getFullYear() - 1, 0, 1);
		var EndDate = new Date(Today.getFullYear() + 1, 11, 1);

		var NextDate = StartDate;

		var z = 0;
		while (NextDate <= EndDate) {
			var nextDesc = NextDate.toLocaleString("default", { month: "long" }) + " - " + NextDate.getFullYear();

			var PastMonth = false;
			var CurrentMonth = false;
			var NextColor = "Black";

			if (NextDate.getFullYear() < Today.getFullYear() || (NextDate.getFullYear() == Today.getFullYear() && NextDate.getMonth() < Today.getMonth())) {
				PastMonth = true;
				NextColor = "Orange";
			}

			if (PastMonth == false) {
				CurrentMonth = NextDate.getMonth() == Today.getMonth() && NextDate.getFullYear() == Today.getFullYear() ? true : false;

				if (CurrentMonth == true) {
					NextColor = "Green";
				}
			}

			var nextEntry: any = {
				ID: z,
				Desc: nextDesc,
				NextColor: NextColor,
				DateVal: new Date(NextDate),
			};

			this.lstMonthYear = [...this.lstMonthYear, nextEntry];

			if (CurrentMonth == true) {
				this.StartMonthYear = nextEntry;
				this.EndMonthYear = nextEntry;
			}

			z++;
			NextDate.setMonth(NextDate.getMonth() + 1);
		}
	}

	loadSemesters() {
		this.SemesterLoading = true;

		var result = this.adminSetupService.SemesterSelectList(this.SchoolID);
		result.subscribe(
			(response) => {
				this.SemesterLoading = false;

				this.lstSemester = response;

				var currentYear = new Date().getFullYear();
				for (var z = 0; z < this.lstSemester.length; z++) {
					var next = this.lstSemester[z];

					var nextStartYear = 0;
					if (next.StartDate != undefined) {
						nextStartYear = new Date(next.StartDate).getFullYear();
					}

					var diff = Math.abs(nextStartYear - currentYear);

					if (diff <= 1) {
						this.SchoolYearSemesters = [...this.SchoolYearSemesters, next];
					}
				}
			},
			(error) => {
				this.SemesterLoading = false;
			}
		);
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Buttons
	////////////////////////////////////////
	onUpdate() {
		var OutputData: any = {
			SelectionID: this.SelectionID,
			DOW: this.DOW,
			SchoolDayID: this.SchoolDayID,
			BellScheduleID: this.BellScheduleID,
			IsOpen: this.IsOpen,
			EveryXDays: this.EveryXDays,
			StartDay: this.StartDay,
			SkipWeekends: this.SkipWeekends,
		};

		this.ref.close(OutputData);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Helpers
	////////////////////////////////////////
	IsLoading() {
		return this.SemesterLoading == true || this.Processing == true;
	}
	////////////////////////////////////////
}
